import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-counter',
  templateUrl: './help-counter.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpCounterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
